import { render, staticRenderFns } from "./AgentStatistic.vue?vue&type=template&id=bf1b9d14&scoped=true&"
import script from "./AgentStatistic.vue?vue&type=script&lang=js&"
export * from "./AgentStatistic.vue?vue&type=script&lang=js&"
import style0 from "./AgentStatistic.vue?vue&type=style&index=0&id=bf1b9d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1b9d14",
  null
  
)

export default component.exports